(function (module) {
    'use strict';

    function ListModifierFactory (_) {

        const factory = {};

        /**
         * Add an object to a list.
         *
         * @param  {Array}    list      An array of objects.
         * @param  {Object}   newItem   A new object to add to the list.
         * @param  {Function} callback  Function to callback when item is remove.
         */
        factory.add = function (list, newItem, callback) {
            if (!list) {
                console.error('list to modify must be defined');
                return;
            }
            // console.info('ListModifierFactory.add[id]:', newItem.id);

            const items = list || [];
            const index = _.findIndex(items, function (item) {
                return Number(newItem.id) === Number(item.id);
            });

            if (index >= 0) {
                // console.info('ListModifierFactory.add[id]:', newItem.id, 'item already exist');
            } else {
                list.push(newItem);
            }

            if (callback && typeof callback === 'function') {
                callback();
            }
        };

        /**
         * Remove an object from a list by using an `id`.
         *
         * @param  {Array}    list          An array of objects.
         * @param  {String}   removedItemId The `id` of the object to remove from the list.
         * @param  {Function} callback      Function to callback when item is remove.
         */
        factory.remove = function (list, removedItemId, callback) {
            if (!list) {
                console.error('list to modify must be defined');
                return;
            }
            // console.info('ListModifierFactory.remove[id]:', removedItemId);
            _.remove(list, function (item) {
                return Number(removedItemId) === Number(item.id);
            });

            if (callback && typeof callback === 'function') {
                callback();
            }
        };

        /**
         * Find an object by `id` in a list and replace it with an updated object.
         *
         * @param  {Array}    list          An array of objects.
         * @param  {Object}   updatedItem   An updated object to add to the list.
         * @param  {Function} callback      Function to callback when item is remove.
         */
        factory.update = function (list, updatedItem, callback) {
            if (!list) {
                console.error('list to modify must be defined');
                return;
            }

            // console.info('ListModifierFactory.update[id]:', updatedItem.id);
            const items = list || [];
            const index = _.findIndex(items, function (item) {
                return Number(updatedItem.id) === Number(item.id);
            });
            items[index] = updatedItem;

            if (callback && typeof callback === 'function') {
                callback();
            }
        };

        factory.updateAttribute = function (list, updateItemId, updatePropName, updatePropValue, callback) {
            if (!list || !updateItemId || !updatePropName) {
                console.error('list, updatePropName & updatePropValue must be defined', {
                    list,
                    updateItemId,
                    updatePropName,
                    updatePropValue
                });
                return;
            }

            // console.info('ListModifierFactory.updateAttribute:', updateItemId, updatePropName, updatePropValue);
            const items = list || [];
            const index = _.findIndex(items, function (item) {
                return Number(updateItemId) === Number(item.id);
            });
            items[index][updatePropName] = updatePropValue;

            if (callback && typeof callback === 'function') {
                callback();
            }
        };

        factory.updateMany = function (list, updateItems) {
            updateItems.forEach((item) => {
                factory.update(list, item);
            });

        };

        return factory;

    }

    module
        .factory('ListModifier', ListModifierFactory);

})(angular.module('rocket.components'));
